import { CategoryQuery as SourceCategoryQuery } from 'SourceQuery/Category.query';
import { Field } from 'Util/Query';

/** @namespace Pwa/Query/Category/Query */
export class CategoryQuery extends SourceCategoryQuery {
    _getDefaultFields() {
        return [
            ...super._getDefaultFields(),
            'additional_description',
            'promo_block',
            this._getPromoCmsBlockField(),
            this._getMwCanonicalUrl(),
        ];
    }

    _getPromoCmsBlockField() {
        return new Field('promo_cms_block').addFieldList(['content']);
    }

    _getMwCanonicalUrl() {
        return new Field('mw_canonical_url').addFieldList(this._getMwCanonicalFields());
    }

    _getMwCanonicalFields() {
        return ['code', 'url'];
    }
}

export default new CategoryQuery();
